import "./Footer.css"
import {Link} from "react-router-dom";
import FlexBox from "../flexbox/FlexBox";
import {Trans, useTranslation} from "react-i18next";

const GoPay = require("../../asset/icons/gopay.svg").ReactComponent;
const CeskoPlatiKartou = require("../../asset/icons/ceskoplatikartou.svg").ReactComponent;


export default function Footer() {
    const {t} = useTranslation();

    return <div className={"footer-container"}>
        <footer>
            <ul className={"footer-col col2"}>
                <li className={"bold"}>{t("footer.support")}</li>
                <li>
                    <Trans i18nKey={"footer.needHelp"} components={{
                        // eslint-disable-next-line jsx-a11y/anchor-has-content
                        discord: <a className={"link-color"} href={"https://discord.ptero-cloud.net"}
                                    target={"_blank"} rel={"noreferrer"}/>
                    }}/>
                    {/*nebo si <Link className={"link-color"} to={"/tickets/new"}>vytvoř ticket</Link>*/}
                </li>
                <li className={"bold"}>{t("footer.store")}</li>
                <li>Email: platby@ptero-cloud.net</li>
                <li>{t("footer.companyId")}: 17348056</li>
                <li><Link to={"/vop"}>{t("footer.terms")}</Link></li>
                <FlexBox justifyContent={"space-between"} gap={"30%"}>
                    <GoPay/>
                    <CeskoPlatiKartou/>
                </FlexBox>
            </ul>
            <ul className={"footer-col col3"}>
                <li className={"bold"}>{t("footer.socialMedia")}</li>
                <li><a href={"https://youtube.ptero-cloud.net"}>YouTube</a></li>
                <li><a href={"https://instagram.ptero-cloud.net"}>Instagram</a></li>
                <li><a href={"https://tiktok.ptero-cloud.net"}>TikTok</a></li>
                <li><a href={"https://minecraft-servery.cz"}>{t("footer.minecraftServers")}</a></li>
            </ul>
            <ul className={"footer-col col3"}>
                <li className={"bold"}>{t("footer.rules")}</li>
                <li><Link to={"/pravidla"}>{t("footer.rulesCzech")}</Link></li>
                <li><Link to={"/rules"}>{t("footer.rulesEnglish")}</Link></li>
                <li><Link to={"/gdpr"}>{t("footer.gdpr")}</Link></li>
            </ul>
        </footer>
        <div className={"copyright"}>
            <p>{t("footer.copyright", {year: new Date().getFullYear()})}</p>
        </div>
    </div>
}